import React from "react";
import { defaultTemplate } from "common/hoc";

function PremiumSubscriptionTemplate({ t }) {
    return <div></div>;
}

export default defaultTemplate(PremiumSubscriptionTemplate);
